module.exports = __webpack_public_path__ + "img/title7.9e57dc00.png";